module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("New York’s meat-packing district was not where people went to see live theater. Located on the West Side, the district’s once gritty meat-packing plants were now occupied by nice restaurants, late-night clubs, and fashion boutiques. The neighborhood had found new life, and a soul all its own.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter had chosen to stage his full-evening magic show in the district for this very reason. By avoiding bustling Times Square, he did not have to compete with the musicals, revivals, and serious dramas that fueled New York’s Theater District. He was the new kid on the block, and his fans ate it up. Each night, they flocked to his shows, desperate to find out what this young miracle-maker would do next in the abandoned meat-packing plant that was his stage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Peter stood inside his dressing room. It took longer to get ready for a magic show than it did to perform one. He was nearly done with his preparations, and he adjusted the elastic pull that ran up the right sleeve of his jacket. The pull was one of his favorite props, and it let him make small objects disappear in the blink of an eye.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stood in front of the mirror and tested the pull. Picking up a playing card, he secretly attached the card to the pull using a small clip. By extending his arms, he made the card race up his sleeve. To the mirror, it looked like real magic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hey, Peter, can you talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was Liza, speaking through the inner-canal earpiece that he wore during his show. Along with being the love of his life, Liza was his assistant, the best he’d ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“As well as the next guy,” he said into the tiny microphone sewn into his shirt collar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Very funny. Everyone’s in their seats. It’s a good crowd.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sold out?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yup. The last tickets got bought right before the doors opened.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s great. Is Snoop there with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s standing next to me. Ready to go over the details?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let ’er rip.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A magician’s assistant wore many hats. Liza and Snoop worked as ushers, and chatted with the patrons as they were led to their seats. Any valuable information they gleaned was passed to Peter before the show began. Magicians called this preshow work. It allowed them to know intimate details about the audience before ever stepping foot on stage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Here we go,” Liza began. “Row A, seats five and six are an older couple from Battle Creek, Michigan, named Wayne and Marilyn Barcomb. Their son, Michael, is about to graduate from NYU Medical School. Michael’s sitting in seat seven. He was talking on his cell phone as they got seated. I think there’s a young lady in the wings.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Engaged?” Peter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It sounds that way. She’s going to meet the parents on Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Did you get her name?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Suzanne.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Another med student?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes—how did you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just a guess. Great job.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thanks, Peter.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Snoop went next. Before joining the show, Snoop had been a computer hacker, and had gotten his nickname because he enjoyed sticking his nose into other people’s business.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re going to love this,” Snoop said. “Row F, seats eight through twelve are five ladies who could be stand-ins for "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Sex and the City,")]), _vm._v(" but actually work in the media department of the J. Walter Thompson advertising agency here in New York. One of them is celebrating a birthday, but I couldn’t find out which one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The birthday girl’s sitting in seat number 10,” Peter told him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Cut it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m serious. I’ll bet you lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No thanks. How do you know she’s in seat number 10?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Simple deduction. Five ladies are out on the town, and one is having a birthday. The birthday girl will sit in the middle so none of her friends will feel left out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wow. I’m impressed,” Snoop said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Merci. Keep going.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Snoop recited the rest of the things he’d overheard while taking patrons to their seats. One lady had a poodle who’d eaten a box of chocolates, and nearly died. Another woman was worried that a passport for a trip to Paris might not come through in time. And one poor man was a recent victim of identity theft, and had been forced to cut up his credit cards. It was just enough information for Peter to open up the door to a person’s psyche, and plumb their thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Want to add anything, Zack?” Peter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Zack handled ticket sales and worked the door. He was a muscle head, and cut an imposing figure. Zack had once handled security for a heavy metal band, and had a sixth sense when it came to spotting trouble. “Sure do. A strange guy with a British accent approached me in the lobby, and asked if you still accepted challenges during the show. He had this way about him that bothered me. When I asked him what he had in mind, he told me to piss off.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Was he drunk?” Peter asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Stoned?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“His breath was clean.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Off in the head?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, he acted pretty normal.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Think he’s a troublemaker?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He sure came across that way. Want me to give him a refund, and ask him to leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everyone in show business had to deal with hecklers. Throwing the guy out on his ass was an option, only there was always the chance he’d file a lawsuit, and cause bigger headaches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Leave him alone,” Peter said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You sure?” Zack replied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Positive. Tell me what he looks like, so I can be on the lookout.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s in his mid-thirties, about six-foot tall, real athletic-looking, with a snarl on his face like a junkyard dog,” Zack said. “He’s got a bad vibe.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lying on his dressing room table was the sketch Peter had drawn after last night’s séance. He picked up the pad and stared at the man he’d nicknamed the Grim Reaper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is he dressed in black?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah. He looks like a funeral director. How did you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Because I saw him last night talking to the dead.")]), _vm._v(" He continued to stare at the pad. What were the chances of the same evil man buying a ticket to his show? About one in a million. He tossed the sketch onto the table.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Where’s he sitting?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Last row, on the aisle,” Zack said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Keep an eye on him. Any sign of trouble, throw him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You still didn’t tell me how you knew what he was wearing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I guessed.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re going to have to tell me how you do that someday.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A backstage buzzer went off. There were five minutes left before the curtain went up. They had a show to do, and Peter put the strange man out of his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good job, everyone,” he said. “Now, let’s go make some magic.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 84
// module chunks = 0